import React, { Fragment } from 'react';
import FormInput from '../form/FormInput';

const divStyle = {
  width: "40%"
};

const ProjectSearchHeader = (props) => (
  <Fragment>
    <div className="col" style={divStyle}>
      <span className="icon-search">&#xe915;</span>
      <FormInput
        name="projectNumber"
        placeholder="Search by Project ID" />
    </div>
    <div className="col" style={divStyle}>
      <span className="icon-search">&#xe915;</span>
      <FormInput
        name="searchText"
        placeholder="Search by Project Name" />
    </div>
  </Fragment>
);

export default ProjectSearchHeader;



// WEBPACK FOOTER //
// ./src/components/projects/ProjectSearchHeader.js